import { render, staticRenderFns } from "./AccountIsActivated.vue?vue&type=template&id=2fc90e40&scoped=true&"
import script from "./AccountIsActivated.vue?vue&type=script&lang=js&"
export * from "./AccountIsActivated.vue?vue&type=script&lang=js&"
import style0 from "./AccountIsActivated.vue?vue&type=style&index=0&id=2fc90e40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc90e40",
  null
  
)

export default component.exports